module.exports = __webpack_public_path__ + "media/tasks/diamond-3ebbc720.svg";